import { OwnUpLargeBodyMedium, PropsWithTheme } from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1)}px;
`;

export const TitleWithIcon = ({ Icon, title }: { Icon: JSX.Element; title: string }) => (
  <Container>
    {Icon}
    <OwnUpLargeBodyMedium variant="body1">{title}</OwnUpLargeBodyMedium>
  </Container>
);
